import { useEffect } from "react";

/** Único SW permitido: el de Web push del módulo de Notificaciones (ver public/sw-notificaciones.js). */
export const SW_NOTIFICACIONES = "/sw-notificaciones.js";

/**
 * Desinstalador de service workers viejos · NO registra nada nuevo.
 *
 * Historia del bug:
 *   1. Habia un PWA con cache-first sobre chunks JS hashed.
 *   2. Al cambiar el chunking de Vite (PR que arreglo `useLayoutEffect`
 *      undefined), los hashes cambiaron pero el SW seguia sirviendo el
 *      bundle viejo · la app no montaba.
 *   3. Hicimos un sw.js kill-switch que se desregistraba y forzaba reload
 *      con `client.navigate(client.url)`.
 *   4. PROBLEMA: este componente vivia dentro de `_authed.tsx`, asi que
 *      al entrar al dashboard tras login se re-registraba el kill-switch,
 *      que volvia a hacer `client.navigate(...)`, que volvia a renderizar
 *      `_authed.tsx`, que volvia a registrar... LOOP INFINITO post-login.
 *
 * Fix definitivo: este componente NO registra ningún SW. Solo, al montar este
 * componente UNA VEZ por sesion del browser, desregistramos cualquier
 * SW activo en el origen (salvo `SW_NOTIFICACIONES`, que registra el perfil
 * al activar Web push y no intercepta peticiones) y borramos sus caches.
 * Despues, todas las requests van directo a la red sin SW interceptando.
 *
 * Cuando todos los browsers de los usuarios hayan ejecutado este cleanup,
 * este componente puede borrarse del codigo. Mientras tanto queda como
 * red de seguridad para visitantes que aun tengan el SW viejo cacheado.
 *
 * El portal es interno · no necesita PWA offline. Si en el futuro
 * se quiere PWA, escribir un sw.js NUEVO que respete hashes de Vite y
 * NUNCA llame a client.navigate() para evitar este loop.
 */
export function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;

    const cleanup = async () => {
      try {
        // 1. Desregistrar cualquier SW existente en este origen, SALVO el de notificaciones
        //    (public/sw-notificaciones.js · sin fetch ni navigate): desregistrarlo cancelaría las
        //    suscripciones Web push del usuario.
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const reg of registrations) {
          const script = (reg.active ?? reg.waiting ?? reg.installing)?.scriptURL ?? "";
          if (script.endsWith(SW_NOTIFICACIONES)) continue;
          await reg.unregister();
        }
        // 2. Borrar todos los Caches API del dominio (los que dejo el SW viejo).
        if ("caches" in window) {
          const names = await caches.keys();
          await Promise.all(names.map((name) => caches.delete(name)));
        }
      } catch (err) {
        console.warn("[sw] cleanup fallo", err);
      }
    };

    void cleanup();
  }, []);

  return null;
}
